import React from "react";

const SignUp = React.lazy(() => import("./Demo/Authentication/SignUp/SignUp"));
const Signin = React.lazy(() => import("./Demo/Authentication/SignIn/SignIn"));

const route = [
  { path: "/auth/SignUp", exact: true, name: "SignUp", component: SignUp },
  { path: "/", exact: true, name: "SignIn", component: Signin },
];

export default route;
